import style from './style.module.css';

export function UserInactive() {
  return (
    <>
      <div className="mt-5 text-center">
        <div className="d-flex justify-content-center mb-5">
          <div className={style.circle}>
            <i className="material-icons-outlined">no_meeting_room</i>
          </div>
        </div>
        <h1>Usuário Inativo</h1>
        <p>Entre em contato com o administrador</p>
      </div>
    </>
  );
}
